import { Component, OnDestroy, OnInit } from "@angular/core";
import { select } from "@angular-redux/store";
import { ServiceControllerStatusEnum, WindowsService } from "../../../models/windows-service";
import { Observable } from "rxjs/Observable";
import { ChannelEvent } from "../../../../pb-screen/services/channel.event.factory";
import { Update } from "./models/update";

@Component({
  selector: "automatic-updates-v2",
  templateUrl: "./automatic-updates-v2.component.html",
  styleUrls: ["./automatic-updates-v2.component.scss"]
})
export class AutomaticUpdatesV2Component implements OnInit, OnDestroy {

  @select("monitorService") monitoringService$: Observable<WindowsService>;
  @select("channelEvents") channelEvents$: Observable<ChannelEvent[]>;

  updates: Update[] = [];
  lastUpdateTimestamp?: number;
  private statusToggleIntervalId?: number;

  monitoringStatusPossibilities = ServiceControllerStatusEnum;

  ngOnInit(): void {
    this.lastUpdateTimestamp = Date.now();

    this.channelEvents$.subscribe((response: ChannelEvent[]) => {
      this.updates = [];
      let latestTimestamp: number | undefined;

      for (const event of response) {
        const data = JSON.parse(event.json).data;
        const eventTimestamp = new Date(event.timestamp).getTime();
        if (!latestTimestamp || eventTimestamp > latestTimestamp) {
          latestTimestamp = eventTimestamp;
        }

        const update: Update = {
          type: data.type,
          timestamp: event.timestamp,
          newPlanningBlocks: data.newPlanningBlocks,
          updatedPlanningBlocks: data.updatedPlanningBlocks,
          deletedPlanningBlocks: data.deletedPlanningBlocks,
          newTransportOrders: data.newTransportOrders,
          updatedTransportOrders: data.updatedTransportOrders,
          deletedTransportOrders: data.deletedTransportOrders,
          deletedTMSReminders: data.deletedTMSReminders,
          updatedTMSReminders: data.updatedTMSReminders

        };

        this.updates.push(update);
      }

      this.updates.reverse();
      if (latestTimestamp) {
        this.lastUpdateTimestamp = latestTimestamp;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.statusToggleIntervalId) {
      window.clearInterval(this.statusToggleIntervalId);
    }
  }

  get lastUpdateLabel(): string | null {
    if (!this.lastUpdateTimestamp) {
      return null;
    }

    const now = Date.now();
    const diffMs = Math.max(0, now - this.lastUpdateTimestamp);
    const diffSeconds = diffMs / 1000;

    if (diffSeconds < 30) {
      return "(active)";
    }

    if (diffSeconds < 60) {
      return "(< 1 min)";
    }

    if (diffSeconds < 11 * 60) {
      let minutes = Math.floor(diffSeconds / 60);
      return `(${minutes} min)`;
    }

    if (diffSeconds < 60 * 60) {
      let minutes = Math.floor(Math.floor(diffSeconds / 60) / 5) * 5;
      return `(${minutes} min)`;
    }

    const diffHours = Math.floor(diffSeconds / 3600);

    if (diffHours <= 8) {
      return `(${diffHours}h)`;
    }

    return "(> 8h)";
  }
}

